"use client";
import { trackPublicEvent } from "./public-analytics";

export function seoAnalyticsAllowed(): boolean {
  try {
    const choice = JSON.parse(window.localStorage.getItem("marginglow_privacy_consent_v1") || "null");
    return choice?.version === "1" && choice?.analytics === true;
  } catch { return false; }
}

// Callers pass fixed page/action labels only. Never include enquiry fields or email addresses.
export function trackSeoEvent(event: string, parameters: Record<string, string> = {}) {
  if (seoAnalyticsAllowed()) trackPublicEvent(event, parameters);
}
